import { trackAdVisible } from '../tracking'

function renderedArticleAds(): HTMLElement[] {
  return [...document.querySelectorAll<HTMLElement>('[data-article-ad]')].filter(
    (ad) => ad.getClientRects().length > 0,
  )
}

up.compiler('[data-article-ad]', (element: HTMLElement) => {
  const position = renderedArticleAds().indexOf(element) + 1
  if (position === 0) {
    return
  }

  // tracking: video_page.ad.article_view
  return trackAdVisible({
    event: 'nativeBanner.visible',
    id: 'ad.article_view',
    text: 'Anzeige',
    params: { banner_position: position },
  })(element)
})
